import { z } from 'zod';
import { slugSchema } from './product.schema.js';

// ─── Sizes ───────────────────────────────────────────────────────────
export const sizeCreateSchema = z.object({
  label: z.string().min(1, 'Rótulo obrigatório').max(20),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export const sizeUpdateSchema = sizeCreateSchema.partial();
export type SizeCreateInput = z.infer<typeof sizeCreateSchema>;
export type SizeUpdateInput = z.infer<typeof sizeUpdateSchema>;

// ─── Colours ─────────────────────────────────────────────────────────
export const colourCreateSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(50),
  hex: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/, 'Hex inválido')
    .nullable()
    .optional(),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export const colourUpdateSchema = colourCreateSchema.partial();
export type ColourCreateInput = z.infer<typeof colourCreateSchema>;
export type ColourUpdateInput = z.infer<typeof colourUpdateSchema>;

// ─── Materials ───────────────────────────────────────────────────────
export const materialCreateSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(100),
  slug: slugSchema,
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export const materialUpdateSchema = materialCreateSchema.partial();
export type MaterialCreateInput = z.infer<typeof materialCreateSchema>;
export type MaterialUpdateInput = z.infer<typeof materialUpdateSchema>;

// ─── Measurement points ──────────────────────────────────────────────
// Garment families a measurement point usually applies to. Used by the admin
// to offer "apply preset" shortcuts; a point may belong to several groups
// (e.g. "Peito" → tops, dresses, outerwear).
export const GARMENT_GROUPS = ['tops', 'bottoms', 'dresses', 'outerwear', 'accessories'] as const;
export const garmentGroupSchema = z.enum(GARMENT_GROUPS);
export type GarmentGroup = z.infer<typeof garmentGroupSchema>;

export const measurementPointCreateSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(100),
  slug: slugSchema,
  garmentGroups: z.array(garmentGroupSchema).default([]),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export const measurementPointUpdateSchema = measurementPointCreateSchema.partial();
export type MeasurementPointCreateInput = z.infer<typeof measurementPointCreateSchema>;
export type MeasurementPointUpdateInput = z.infer<typeof measurementPointUpdateSchema>;

// ─── Tags ────────────────────────────────────────────────────────────
export const tagCreateSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(100),
  slug: slugSchema,
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export const tagUpdateSchema = tagCreateSchema.partial();
export type TagCreateInput = z.infer<typeof tagCreateSchema>;
export type TagUpdateInput = z.infer<typeof tagUpdateSchema>;
